import { Button, Popover, Row, Col, Avatar, Divider, Space, Tooltip, Spin } from 'antd'
import {
  UserOutlined,
  TeamOutlined,
  RightOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
} from '@ant-design/icons'
import styles from './userInfoPanelPopover.module.less'
// import { onLogout } from '@/common/utils.ts'
// import { useNavigate } from 'react-router-dom'
import { useDebounceEffect, useSetState, useUpdateEffect } from 'ahooks'
import { IconCorrect } from '@/components/icons'
import classNames from 'classnames'
import useUser from '@/hooks/useUser.ts'
import { useNavigate } from 'react-router-dom'
import { changeTenant, getTenantList, X_TRANSFER_KEY } from '@/services'
import {
  getLocalTenants,
  getUser,
  saveToken,
  setLocalTenants,
  userChangeRemoveStore,
} from '@/common/utils.ts'
import { getFileUrlPrefix } from 'shj-utils'
import useGlobalStore, { themeList } from '@/store'
import { useAliveController } from 'react-activation'
import { triggerEvent } from '@/utils/customEvent.ts'
import { batchSave } from '@/services/cache.ts'
import { setThemeRoot } from '@/utils/common.ts'
import { IdentityItem } from '@/layouts/MenuSide/IdentityItem.tsx'
import { changeUserIdentity } from '@/services/user.ts'

const UserInfoPanelPopover = props => {
  const navigate = useNavigate()
  const currentTenant = localStorage.getItem(X_TRANSFER_KEY)
  const {
    // onModifyPassword,
    onChangePosition,
    userInfo,
    logout,
  } = props
  // const navigate = useNavigate()
  const { updateUserDeptPos, saveUserToken, getProfile } = useUser()
  const { refresh, refreshScope, getCachingNodes, clear } = useAliveController()
  // const userInfo = getUser() || {}
  const [state, setState] = useSetState({
    deptPosId: userInfo?.currentDepartmentPosition?.id,
    logoutLoading: false,
    loadingId: null,
    tenants: [],
    chooseTenant: '',
  })

  const identities = useGlobalStore((state: any) => state.identities)
  const setTheme = useGlobalStore((state: any) => state.setTheme)
  const saveTheme = useGlobalStore((state: any) => state.saveTheme)

  // console.log('userInfo', userInfo)
  useDebounceEffect(
    () => {
      getTenantList().then(data => {
        setState({ tenants: data || [] })
      })
      // console.log('userInfo', userInfo)
    },
    [],
    { wait: 200 }
  )

  useUpdateEffect(() => {
    setState({ deptPosId: userInfo?.currentDepartmentPosition?.id })
  }, [userInfo])

  const handleChangePosition = record => {
    // console.log('record', record)
    if (isPositionActive(record)) return
    const result = onChangePosition?.(record.id)
    if (result instanceof Promise) {
      setState({ loadingId: record.id })
      result.then((res) => {
        setState({ deptPosId: record.id, loadingId: null })
        updateUserDeptPos(record)
        window.location.reload()
      })
    }
  }

  const changeTenantFn = (tenantId: string) => {
    if (tenantId === localStorage.getItem(X_TRANSFER_KEY)) return
    setState({ chooseTenant: tenantId })
    changeTenant(tenantId).then(res => {
      const { accessToken, refreshToken, extend } = res || {}
      saveToken(accessToken.token)
      localStorage.setItem('refreshToken', refreshToken.token)
      localStorage.setItem('refreshExpireAt', refreshToken.expireAt)
      localStorage.setItem('expireAt', accessToken.expireAt)
      localStorage.setItem(X_TRANSFER_KEY, tenantId)
      if (extend) {
        localStorage.setItem('userExtend', JSON.stringify(extend))
      }
      window.location.reload()
      window.location.href = '/main'
      // setState({ chooseTenant: '' })
    })
  }

  const deptPosition =
    userInfo?.currentDepartmentPosition?.name || userInfo?.currentDepartmentPosition?.name
  // console.log('deptPosition', userInfo?.extend, userInfo)

  const onUserSetting = () => {
    navigate('/main/personalCenter')
  }

  const handleLogout = () => {
    gio?.('clearUserId')
    setState({ logoutLoading: true })
    logout().finally(() => setState({ logoutLoading: true }))
  }

  const changeTheme = record => {
    // const nodes = getCachingNodes?.()
    // clear()
    // nodes.map(node => {
    //   refresh(node.name)
    //   refreshScope(node.name)
    // })

    triggerEvent('theme-change', record.theme)
    setThemeRoot(record.theme)
    setTheme(record.theme)
    return saveTheme(record.key, record.theme)
  }

  const isPositionActive = record => {
    const posId = state.deptPosId || userInfo?.currentDepartmentPosition?.id
    return posId === record.id
  }

  const switchIdentity = async item => {
    if (state.loadingId) return
    setState({ loadingId: item.id })
    const res: any = await changeUserIdentity(item.id)

    sessionStorage.removeItem('PROFILE_FETCHED')
    saveUserToken(res)
    userChangeRemoveStore()
    await Promise.all([getProfile()])

    setState({ loadingId: void 0 })
    navigate('/main')
    localStorage.removeItem('tipsShow') // 删除判断变量，重新展示登录身份提示弹框

    // console.log('switchIdentity', res)
    window.location.reload()
  }

  const getCurrentIdentity = () => {
    const user = getUser()
    if (!user?.currentRoleIds) return null
    return identities.find(d => user.currentRoleIds.includes(d.roleId) && (user.orgId === d.orgId))
  }
  const currentIdentity = getCurrentIdentity()
  return (
    <Popover
      // placement="bottomRight"
      placement="right"
      overlayInnerStyle={{
        padding: 0,
      }}
      arrow={false}
      // open={true}
      content={
        <div style={{ minWidth: 320, maxWidth: 360, padding: '6px 0 8px' }}>
          <div className={styles.userInfoRow} style={{ padding: '7px 17px' }}>
            <Row gutter={20} align="middle">
              <Col>
                <Avatar
                  style={{ cursor: 'pointer' }}
                  size={64}
                  icon={<UserOutlined />}
                  src={userInfo.photo}
                  onClick={() => navigate('/main/personalCenter')}
                />
              </Col>
              <Col flex={1}>
                <Row justify="space-between" align="middle">
                  <Col>
                    <div className={styles.userName}>
                      {userInfo?.name}
                      {!userInfo.alias || userInfo?.name === userInfo?.alias
                        ? ''
                        : `(${userInfo?.alias})`}
                    </div>
                  </Col>
                </Row>
                {state.tenants.length > 1 ? (
                  <Popover
                    placement="rightTop"
                    title={null}
                    arrow={false}
                    overlayInnerStyle={{
                      padding: 5,
                      marginLeft: 8,
                      overflow: 'hidden',
                      maxWidth: 200,
                    }}
                    content={state.tenants.map((tenant: any) => (
                      <Tooltip title={tenant.name} placement="right" key={tenant.id}>
                        <Button
                          type="text"
                          block
                          key={tenant.id}
                          disabled={tenant.tenantId === currentTenant || !!state.chooseTenant}
                          className={classNames([
                            styles.tenant,

                            tenant.tenantId === currentTenant && styles.tenant_active,
                          ])}
                          onClick={() => changeTenantFn(tenant.tenantId)}
                        >
                          <div className={styles.ellipsis}>{tenant.name}</div>
                        </Button>
                      </Tooltip>
                    ))}
                  >
                    <div className={styles.company}>
                      <Tooltip
                        placement="topLeft"
                        title={state.tenants.find(item => item.tenantId === currentTenant)?.name}
                      >
                        <p className={classNames([styles.ellipsis, styles.mx_w150])}>
                          {state.tenants.find(item => item.tenantId === currentTenant)?.name}
                        </p>
                      </Tooltip>
                      <div className={styles.right_icon}>
                        <RightOutlined />
                      </div>
                    </div>
                  </Popover>
                ) : (
                  <div className={styles.company}>
                    {state.tenants.find(item => item.tenantId === currentTenant)?.name}
                  </div>
                )}
              </Col>
            </Row>
          </div>

          <Divider style={{ margin: 4 }} />

          {/*{userInfo.departPositions?.map?.(d => {*/}
          {/*  const isActive = isPositionActive(d)*/}
          {/*  // const rowText = `${d.companyName} / ${d.deptName} / ${d.name}啊哈哈哈哈哈哈嘎嘎哦嘿啊哈哈哈哈哈哈嘎嘎哦嘿`*/}

          {/*  const rowText = [d.companyName, d.deptName, d.name].filter(item => !!item).join(' / ')*/}
          {/*  const showTips = rowText.length > 26*/}
          {/*  return (*/}
          {/*    <div className={classNames(styles.userInfoRow, styles.noPadding)} key={d.code}>*/}
          {/*      <Tooltip*/}
          {/*        title={rowText}*/}
          {/*        open={showTips ? undefined : false}*/}
          {/*        overlayStyle={{ maxWidth: 340 }}*/}
          {/*        placement="bottomRight"*/}
          {/*      >*/}
          {/*        <Spin spinning={d.id === state.loadingId}>*/}
          {/*          <Button*/}
          {/*            type="text"*/}
          {/*            block*/}
          {/*            size="large"*/}
          {/*            className={styles.rowButton}*/}
          {/*            style={{*/}
          {/*              textAlign: 'left',*/}
          {/*              fontSize: 12,*/}
          {/*              borderRadius: 0,*/}
          {/*              paddingLeft: 32,*/}
          {/*              paddingRight: 32,*/}
          {/*            }}*/}
          {/*            disabled={state.loadingId !== null}*/}
          {/*            onClick={() => handleChangePosition(d)}*/}
          {/*          >*/}
          {/*            {rowText}*/}
          {/*          </Button>*/}
          {/*        </Spin>*/}
          {/*      </Tooltip>*/}

          {/*      {isActive ? (*/}
          {/*        <div className={styles.positionActive}>*/}
          {/*          <IconCorrect />*/}
          {/*        </div>*/}
          {/*      ) : null}*/}
          {/*    </div>*/}
          {/*  )*/}
          {/*})}*/}
          <div className={styles.userInfoRow}>
            <Popover
              // placement="rightTop"
              placement="right"
              title={null}
              arrow={false}
              overlayInnerStyle={{
                padding: '0',
                overflow: 'hidden',
                overflowY: 'auto',
                maxHeight: 'calc(100vh - 100px)',
                width: 260,
              }}
              content={
                <>
                  {identities.map?.((d, i) => {
                    const isActive = d.roleId === currentIdentity?.roleId && d.orgId === currentIdentity?.orgId
                    return (
                      <IdentityItem
                        key={`identity_${i}`}
                        data={d}
                        isActive={isActive}
                        loading={state.loadingId === d.id}
                        onClick={isActive ? void 0 : () => switchIdentity(d)}
                      />
                    )
                  })}
                </>
              }
            >
              <Button
                type="text"
                block
                size="large"
                className={styles.rowButton}
                style={{
                  display: 'block',
                  textAlign: 'left',
                  fontSize: 12,
                  borderRadius: 0,
                  paddingLeft: 32,
                  paddingRight: 32,
                  paddingTop: 4,
                  paddingBottom: 4,
                  height: 50,
                  justifyContent: 'start',
                }}
                disabled={state.loadingId !== null}
                // onClick={() => handleChangePosition(d)}
              >
                <div style={{ marginBottom: 4 }}>{currentIdentity?.roleName}</div>
                <span style={{ color: '#aaa' }}>{currentIdentity?.orgNamePath}</span>
              </Button>
              <div className={styles.rightArrow}>
                <RightOutlined />
              </div>
            </Popover>
          </div>
          <Divider style={{ margin: 4 }} />

          <div className={styles.userInfoRow}>
            <Button
              type="text"
              block
              style={{
                textAlign: 'left',
                paddingLeft: 32,
                borderRadius: 0,
                justifyContent: 'start',
              }}
              onClick={onUserSetting}
            >
              个人设置
            </Button>
          </div>
          <div className={styles.userInfoRow}>
            <Popover
              placement="rightTop"
              title={null}
              arrow={false}
              overlayInnerStyle={{
                padding: '10px 15px',
                // marginLeft: 15,
                overflow: 'hidden',

                width: 410,
              }}
              content={
                <Row gutter={15}>
                  {themeList.map((d, i) => {
                    return ['green', 'lightBlue', 'red'].includes(d.key) ? (
                      <Col
                        key={`theme_${i}`}
                        span={8}
                        className={styles.themeItem}
                        onClick={() => changeTheme(d)}
                      >
                        <div className={styles.themeColor} style={{ backgroundColor: d.color }}>
                          <AlignLeftOutlined style={{ transform: 'rotate(-90deg)' }} />
                          <AlignRightOutlined style={{ transform: 'rotate(90deg)' }} />
                        </div>
                        <div className={styles.themeText}>{d.name}</div>
                      </Col>
                    ) : null
                  })}
                </Row>
              }
            >
              <Button
                type="text"
                block
                style={{
                  textAlign: 'left',
                  paddingLeft: 32,
                  borderRadius: 0,
                  justifyContent: 'start',
                }}
              >
                主题设置
              </Button>
              <div className={styles.rightArrow}>
                <RightOutlined />
              </div>
            </Popover>
          </div>
          <div className={styles.userInfoRow}>
            <Button
              type="text"
              block
              style={{
                textAlign: 'left',
                paddingLeft: 32,
                borderRadius: 0,
                justifyContent: 'start',
              }}
              loading={state.logoutLoading}
              onClick={handleLogout}
            >
              退出登录
            </Button>
          </div>
        </div>
      }
    >
      {props.children}
    </Popover>
  )
}

export default UserInfoPanelPopover
